<template>
  <div>
    <div class="modal show fade modal text-left " style="display: block;" v-if="show">
      <div class="modal-dialog modal-sm">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" style="text-transform:capitalize;">
              Update Department
            </h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('hide')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="validate-form mt-2">
                  <div class="row">
                    <div class="col-12 ">
                      <div class="form-group">
                        <label for="account-name">Department Name</label>
                        <input type="text" class="form-control" id="account-name" name="name" placeholder="Name"
                           />
                      </div>
                    </div>
                    <div class="col-12 ">
                      <div class="form-group">
                        <label for="account-name">Status </label>
                        <select class="form-control">
                            <option>Active</option>
                            <option>Inactive</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </form>
          </div>
          <div class="modal-footer justify-content-center">
            <button type="button" @click="$emit('hide')" class="btn btn-primary mt-2 mr-1">Save changes</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="show" class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
export default {
  props: ['show', 'data', 'index'],
  data() {
    return {
      list: []
      // showModal: false,
    };
  },
  methods: {
  },
  watch: {
    show() {
      this.list = this.data
    },
  }
};
</script>

<style scoped>
.modal {
  display: block !important;
  /* I added this to see the modal, you don't need this */
}

/* Important part */
.modal-dialog {
  overflow-y: initial !important
}

.modal-body {
  height: 70vh;
  overflow-y: auto;
}
</style>
